<template>
  <div class="form">
    <div class="commit-info">
      <section class="base-info">
        <div class="header" v-if="info.result === '2'">
          <z-icon name="cross" color="#FF3A30" size="30px"></z-icon><b class="reject">申诉未通过</b>
        </div>
        <div class="header" v-if="info.result === '1'">
          <z-icon name="success" color="#34C758" size="30px"></z-icon><b class="pass">申诉通过</b>
        </div>
        <div class="detial" v-if="info.result === '1'">{{ info.resultText }}</div>
        <div class="detial" v-if="info.result === '2'">
          <span v-if="info.link">{{
            info.resultText.slice(0, info.resultText.indexOf('点击此处'))
          }}</span>
          <b v-if="info.link" class="gotoPage" @click="gotoPage(info.link)">点击此处</b>
          <span v-if="info.link">{{
            info.resultText.slice(info.resultText.indexOf('点击此处') + 4, info.resultText.length)
          }}</span>
          <span v-else>{{ info.resultText }}</span>
        </div>
      </section>
      <section class="product-info">
        <div class="title">申诉详情</div>
        <div class="appeal-info" v-show="info.depositId">
          <div class="appeal-info-item">
            申诉时间：<span>{{ info.appealTime }}</span>
          </div>
          <div class="appeal-info-item">
            详情描述：<span>{{ info.appealReason }}</span>
          </div>
          <div class="upload-area">
            <div
              class="img-file"
              v-for="(item,index) in info.picList.filter(Boolean)"
              :key="index"
              :style="{ backgroundImage: 'url(' + $setPicSize(item) + ')' }"
            ></div>
            <div class="empty" style="clear: both;"></div>
          </div>
        </div>
      </section>
      <section class="product-info">
        <div class="title" @click="goToDetial()">
          与当前保证金相关的商品详情
          <!-- <span class="orderDetial"
                @click="goToDetial()">详情</span> -->
        </div>
        <div class="info" v-show="info.depositId">
          <div class="pic" @click="goToDetial()">
            <div
              class="pic-core"
              :style="{ backgroundImage: 'url(' + $setPicSize(info.infoPic) + ')' }"
            />
          </div>
          <div class="left-info">
            <div class="left-info-title">
              商品标题：<span>{{ info.infoTitle }}</span>
            </div>
            <div class="left-info-title">
              商品描述：<span>{{ info.infoContent }}</span>
            </div>
            <div class="left-info-title">
              商品价格：<span>{{ info.infoPrice }}</span>
            </div>
            <div class="left-info-title">
              保证金ID：<span class="copy-link" :data-clipboard-text="info.depositId">{{
                info.depositId
              }}</span>
            </div>
            <div class="left-info-title">
              保证金金额：<span>{{ info.depositAmount }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="form-bottom" @click="closePage()">
      <div class="form-bottom-text">返回</div>
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { Toast } from '@zz-common/zz-ui'
import { getdepositauditinfo } from '@api/resourceApi'
import { lego } from '@zz-common/lego'
import { toast } from '../../native'
import { queryParams, getCookie } from '../../lib/utils'
// import copy from '../../lib/copy'
const query = queryParams()

export default {
  name: 'uploadExample',
  data() {
    return {
      auditId: query.auditId || this.$route.query.auditId,
      info: {
        result: '',
        resultText: '',
        link: '',
        picList: [],
        appealReason: '',
        infoContent: '',
        depositAmount: '',
        depositId: '',
        infoTitle: '',
        appealTime: '',
        infoPic: '',
        infoPrice: ''
      }
    }
  },
  computed: {},
  methods: {
    init() {
      this.loading = true
      const params = {}
      if (this.auditId) params.auditId = this.auditId
      return getdepositauditinfo({ ...params })
        .then((respData) => {
          console.log('---respData', respData)
          this.loading = false
          const { status = '', msg = '', data = {} } = respData
          const { picList = '' } = data
          if (+status !== 0) {
            return toast({
              msg: msg || '获取申诉信息错误',
              style: '2'
            })
          }
          this.info = { ...data, picList: picList.split('|') }
          lego.send({
            pagetype: 'ZZUP_BONDRESULT',
            actiontype: 'PAGE_SHOW',
            backup: {
              result: this.info.result,
              uid: getCookie('uid')
            }
          })
          return respData
        })
        .catch((err) => {
          this.code = ''
          toast({
            msg: err.message || '获取申诉信息错误',
            style: '2'
          })
        })
    },
    goToDetial() {
      native.wrap('enterDetail')({
        infoId: this.info.infoId,
        from: 'm'
      })
    },
    gotoPage() {
      lego.send({
        pagetype: 'ZZUP_BONDRESULT',
        actiontype: 'CLICK',
        backup: {
          result: this.info.result,
          uid: getCookie('uid')
        }
      })
      native.skipToUrl({ targetUrl: this.info.link })
    },
    $setPicSize(url) {
      return setPicSize(url, 400, 400)
    },
    closePage() {
      native.close()
    }
  },
  mounted() {
    native.setTitle({
      title: '保证金申诉反馈通知'
    })
    const clipboard = new ClipboardJS('.copy-link')
    clipboard.on('success', function(e) {
      console.info('Action:', e.action)
      console.info('Text:', e.text)
      console.info('Trigger:', e.trigger)
      Toast(`保证金ID ${e.text} 复制成功`)
      e.clearSelection()
    })

    clipboard.on('error', function() {
      Toast('不支持自动复制，请手动复制')
    })
    this.init()
  },
  components: {
    // zIcon: Icon,
    // Toast
  },
  beforeRouteEnter(_to, _from, next) {
    next(() => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import './Result.less';
</style>
